import { render } from "./WechatUserSelector.vue?vue&type=template&id=4a1e27c4&scoped=true"
import script from "./WechatUserSelector.vue?vue&type=script&lang=js"
export * from "./WechatUserSelector.vue?vue&type=script&lang=js"

import "./WechatUserSelector.vue?vue&type=style&index=0&id=4a1e27c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1e27c4"]])

export default __exports__